<template>
  <v-container fluid pa-0 ma-0>

    <v-toolbar class="pa-0 ma-0 toolbar-shadow"
               color="white" flat fixed app>
      <v-btn small flat icon @click="$router.go(-1)">
        <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <h3 class="display-2" style="margin-bottom: 2px" v-text="'게시글'"></h3>
      <v-spacer></v-spacer>
      <v-btn class="menu-icon" small icon @click.stop="menu = true">
        <v-icon size="24px">$vuetify.icons.menuEllipsis</v-icon>
      </v-btn>
    </v-toolbar>

    <v-layout row wrap class="ma-0" v-scroll="bottomVisible">
      <v-flex xs12 v-if="loading">
        <v-progress-circular indeterminate style="margin: auto; margin-top: 100px;"></v-progress-circular>
      </v-flex>

      <v-flex xs12 v-show="!loading" ref="content" style="background-color: white;">
        <v-layout align-center class="pa-3">
          <v-chip v-if="post.menus" small class="custom-chip-small custom-chip-background">{{ post.menus.name }}</v-chip>
          <v-chip v-if="post.nations" small class="custom-chip-small">{{ post.nations.name }}</v-chip>
<!--          <v-spacer></v-spacer>-->
<!--          <v-layout row align-center style="flex-shrink: 0; flex-grow: 0;">-->
<!--            <v-icon color="#a9a9af" size="16px">$vuetify.icons.visible</v-icon>-->
<!--            <span style="color: #969596; font-size: 12px; line-height: 12px; letter-spacing: -0.3px; margin-left: 8px;" v-text="post.view_cnt"></span>-->
<!--          </v-layout>-->
        </v-layout>

        <div class="post-title">
          <span v-if="post.title">{{ post.title }}</span>
          <span v-else>제목 없는 글</span>
        </div>

        <div v-if="post.image_list">
          <div class="feed-swiper-container swiper-container">
            <div class="feed-swiper-wrapper swiper-wrapper">
              <div class="feed-swiper-slide swiper-slide" v-for="(image, index) of post.image_list" :key="index">
                <!-- TODO: fallback image list -->
                <v-img :src="`${$storage}/post/${image}`"
                       :aspect-ratio="16/9"
                       class="grey lighten-5"
                       @click.stop="toggleImageViewer({ flag: true, images: fullSrcImages, startIndex: index })">
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </div>
            </div>

            <div v-show="post.image_list.length > 1" class="feed-swiper-pagination swiper-pagination"></div>
          </div>
        </div>

        <v-card tile flat class="mt-3 px-3 py-0">
          <v-card-text class="pa-0 ma-0 text-xs-left body-2" v-html="linkedContents"></v-card-text>
<!--          <v-card-text class="text-xs-left tag-style" v-if="post.hashtag">-->
<!--            <span class="d-inline-block mr-1" v-for="(tag, index) of post.hashtag" :key="index" v-text="`#${tag}`"></span>-->
<!--          </v-card-text>-->
        </v-card>

        <v-card tile flat class="flex card-shadow">
          <v-list-tile class="grow pb-3 pt-5">
            <v-list-tile-avatar>
              <v-img size="40px" :src="profileImageSrc" lazy-src="@/assets/img/profile-default.png" @error="isProfileLoaded = false"></v-img>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <span class="user-name" v-text="post.user.name"></span>
              <span class="caption">{{ published }}</span>
            </v-list-tile-content>

            <v-layout align-center justify-end style="flex-grow: 0;">
              <v-layout column align-center>
                <v-btn icon small class="my-0">
                  <v-icon color="#4a4a4a">$vuetify.icons.commentOutlined</v-icon>
                </v-btn>
                <span class="counter" v-text="post.comment_cnt"></span>
              </v-layout>

              <v-layout column align-center>
                <v-btn icon small @click="like(post.idx)" class="my-0">
                  <v-icon :color="post.likes ? '#ec2f54' : '#4a4a4a'">{{ post.likes ? '$vuetify.icons.heartFilled' : '$vuetify.icons.heartOutlined' }}</v-icon>
                </v-btn>
                <span class="counter" v-text="post.like_cnt"></span>
              </v-layout>

              <v-layout column align-center>
                <v-btn icon small @click="bookmark(post.idx)" class="my-0">
                  <v-icon color="#4a4a4a">{{ post.bookmarks ? '$vuetify.icons.bookmarkFilled' : '$vuetify.icons.bookmarkOutlined' }}</v-icon>
                </v-btn>
                <span class="counter" v-text="post.bookmark_cnt"></span>
              </v-layout>
            </v-layout>

          </v-list-tile>
        </v-card>
      </v-flex>

      <v-flex xs12 class="mt-2" v-show="!loading" style="padding-bottom: 74px;">
        <v-card tile flat class="card-shadow pa-0 ma-0">
          <v-list class="pa-0 px-3">
            <CommentListTile v-for="(comment, index) of post.comments" :key="index"
                             :idx="comment.idx"
                             :postIdx="comment.post_idx"
                             :createdAt="comment.created_at"
                             :updatedAt="comment.updated_at"
                             :contents="comment.contents"
                             :likeCnt="comment.like_cnt"
                             :likes="comment.likes"
                             :user="comment.user"
                             :recommentCnt="comment.recomment_cnt"
                             :recomments="comment.recomments"
                             @like="likeReply"
                             @comment="recomment"
                             @report="reportReply"
                             @remove="removeReply"
                             @moreRecomment="selectMore" />
          </v-list>
        </v-card>
      </v-flex>

      <v-footer height="auto"
                class="pa-3"
                fixed
                color="#f8f8f8"
                style="width: 100%;">
        <v-textarea class="border-radius-custom"
                    solo flat hide-details
                    auto-grow
                    rows="1"
                    placeholder="댓글"
                    v-model="comment"
                    ref="comment">
          <template v-slot:append>
            <v-btn fab :disabled="comment.replace(/[\r\n]+/g, '') === ''"
                   outline small color="#ec2f54"
                   class="ma-0 submit-comment"
                   @click="submitComment">
              <span>게시</span>
            </v-btn>
          </template>
        </v-textarea>
      </v-footer>

      <!-- 게시글 메뉴 -->
      <v-dialog v-model="menu" max-width="240px">
        <v-card>
          <v-card-title class="display-4">게시글 설정</v-card-title>

          <v-card-text>
            <v-list class="pa-0 ma-0">
              <template v-for="(item, index) in menus">
                <v-list-tile v-if="typeof item.owner === 'undefined' || (isOwner ? item.owner : !item.owner)" :key="index" @click="item.method">
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile>
              </template>
            </v-list>
          </v-card-text>

          <v-card-actions>
            <v-btn flat block @click="menu = false">취소</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- 임시 스낵바 -->
      <v-snackbar v-model="snackbar" bottom vertical :timeout="3000" auto-height>
        {{ snackbarMessage }}
        <v-btn color="primary" flat @click="snackbar = false">닫기</v-btn>
      </v-snackbar>

    </v-layout>
  </v-container>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';

  import CommentListTile from '@/components/CommentListTile';
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import { timeToDotString, urlToLink } from '@/util/util'

  export default {
    name: 'Feed',
    props: [ 'idx' ],
    components: { CommentListTile },
    computed: {
      ...mapGetters([ 'now' ]),
      ...mapGetters('post', [ 'post' ]),
      ...mapGetters('user', { userIdx: 'idx' }),
      profileImageSrc () {
        return this.post.user.profile_image && this.isProfileLoaded
          ? `${this.$storage}/user/profile/${this.post.user.profile_image}`
          : require('@/assets/img/profile-default.png');
      },
      published () {
        return timeToDotString(this.post.created_at, this.post.created_at, this.now);
      },
      isOwner () {
        return this.userIdx === this.post.user.idx;
      },
      linkedContents () {
        return urlToLink(this.post.contents);
      },
      fullSrcImages () {
        if (this.post.image_list) {
          let arr = [];
          this.post.image_list.forEach(el => {
            arr.push(`${this.$storage}/post/${el}`);
          });
          return arr;
        }
        return [];
      }
    },
    data () {
      return {
        time: parseInt(new Date().getTime() / 1000),
        page: 1,
        menu: false,
        isProfileLoaded: true,
        comment: '',
        swiper: null,
        recommentTo: -1, // commentIdx
        snackbarMessage: '',
        snackbar: false,
        bottom: true,
        menus: [
          // { owner: undefined, name: '링크 복사하기', method: '' },
          // { owner: false, name: '신고하기', method: '' },
          { owner: false, name: '게시글 숨기기', method: () => this.hide(this.idx) },
          { owner: true, name: '게시글 삭제', method: () => this.delete(this.idx), }
        ],
        loading: true,
      };
    },
		metaInfo () {
			return {
				title: this.post.title + ' - 유스',
				meta: [
					// SEO 설정
					{ name: 'description', content: this.post.contents },
					// SNS 설정
					{ property: 'og:title', content: this.post.title + ' - 유스' },
					{ property: 'og:description', content: this.post.contents },
					{ property: 'og:url', content: "https://www.youth.lol" + window.location.pathname },
					// 모바일 최적화
					{ name: 'viewport', content: 'width=device-width, initial-scale=1' }
				]
			}
		},
    created () {
      this.selectPost(this.idx).then(() => {
        this.selectComments({ second: this.time, idx: this.idx, page: this.page}).then(() => {
          this.page++;
        });
        this.loading = false;
      });
    },
    mounted () {
      if (this.post.image_list) {
        this.swiper = new Swiper('.feed-swiper-container', {
          direction: 'horizontal',
          // width: window.innerWidth,
          // height: window.innerWidth * 9 / 16,
          pagination: {
            el: '.feed-swiper-pagination',
          },
        });
      }
    },
    updated () {
      if (this.swiper) this.swiper.update();
      else if (this.post.image_list) {
        this.swiper = new Swiper('.feed-swiper-container', {
          direction: 'horizontal',
          // width: window.innerWidth,
          // height: window.innerWidth * 9 / 16,
          pagination: {
            el: '.feed-swiper-pagination',
          },
        });
      }
    },
    beforeDestroy () {
      if (this.swiper) this.swiper.destroy();
    },
    watch: {
      comment (text) {
        if (text === '') {
          this.recommentTo = -1;
        }
      },
      bottom (bottom, oldBottom) {
        if (bottom && !oldBottom) {
          this.selectComments({ second: this.time, idx: this.idx, page: this.page}).then(() => {
            this.page++;
          });
        }
      },
    },
    methods: {
      ...mapActions([ 'toggleImageViewer' ]),
      ...mapMutations('post', { mutationToggleLike: 'TOGGLE_LIKE', mutationToggleBookmark: 'TOGGLE_BOOKMARK' }),
      ...mapActions('post', [
        'selectComments', 'selectRecomments', 'selectPost', 'deletePost', 'hidePost',
        'toggleLike', 'toggleBookmark', 'createComment', 'toggleLikeComment', 'toggleLikeRecomment',
        'reportComment', 'reportRecomment', 'createRecomment', 'deleteComment', 'deleteRecomment',
      ]),
      bottomVisible () {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight - 200;
        this.bottom = bottomOfPage || pageHeight < visible;
      },
      like (idx) {
        this.toggleLike(idx).then(response => {
          this.mutationToggleLike({ idx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      bookmark (idx) {
        this.toggleBookmark(idx).then(response => {
          this.mutationToggleBookmark({ idx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      hide (idx) {
        this.hidePost(idx).then(response => {
          this.menu = false;
          if (response.data) this.showSnackbar('글을 숨겼습니다.');
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        }).catch(err => {
          this.showSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
          console.error(err);
        });
      },
      delete (idx) {
        this.deletePost(idx).then(response => {
          this.menu = false;
          if (response.data) this.showSnackbar('글이 삭제되었습니다.');
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        }).catch(err => {
          this.showSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
          console.error(err);
        });
      },
      submitComment () {
        if (this.comment.replace(/[\r\n]+/g, '') === '') return false;
        if (this.recommentTo > -1) {
          this.createRecomment({ postIdx: this.idx, commentIdx: this.recommentTo, content: this.comment }).then(() => {
            window.scrollTo(0, this.$refs.content.scrollHeight - 50); // TODO: recomment 작성한 글위치로 스크롤
            this.comment = '';
            this.$refs.comment.$refs.input.style.height = '';
          })
        } else {
          this.createComment({ idx: this.idx, content: this.comment }).then(() => {
            window.scrollTo(0, this.$refs.content.scrollHeight - 50);
            this.comment = '';
            this.$refs.comment.$refs.input.style.height = '';
          });
        }
      },
      // payload: { postIdx, commentIdx, idx }
      // 만약 payload.commentIdx 가 undefined 인 경우 idx = commentIdx,그렇지 않은 경우 id = recommentIdx
      likeReply (payload) {
        console.log('likecomment', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.toggleLikeComment({ postIdx: payload.postIdx, commentIdx: payload.idx });
        } else {
          this.toggleLikeRecomment({ postIdx: payload.postIdx, commentIdx: payload.commentIdx, recommentIdx: payload.idx });
        }
      },
      recomment (payload) {
        console.log('recomment', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.comment = `@${payload.commentUserName} `;
          this.recommentTo = payload.idx;
        } else {
          this.comment = `@${payload.commentUserName} `;
          this.recommentTo = payload.commentIdx;
        }
        this.$refs.comment.focus();
      },
      reportReply (payload) {
        console.log('report', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.reportComment({ postIdx: payload.postIdx, commentIdx: payload.idx }).then(response => {
            if (!response.data) this.showSnackbar('이미 신고한 댓글입니다.');
            else this.showSnackbar('댓글이 신고되었습니다.');
          }).catch(err => {
            console.error(err);
          });
        } else {
          this.reportRecomment({ postIdx: payload.postIdx, commentIdx: payload.commentIdx, recommentIdx: payload.idx }).then(response => {
            if (!response.data) this.showSnackbar('이미 신고한 댓글입니다.');
            else this.showSnackbar('댓글이 신고되었습니다.');
          }).catch(err => {
            console.error(err);
          });
        }
      },
      removeReply (payload) {
        console.log('remove', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.deleteComment({ postIdx: payload.postIdx, commentIdx: payload.idx });
        } else {
          this.deleteRecomment({ postIdx: payload.postIdx, commentIdx: payload.commentIdx, recommentIdx: payload.idx });
        }
      },
      showSnackbar (message) {
        this.snackbarMessage = message;
        this.snackbar = true;
      },
      selectMore (payload) {
        console.log('moreRecomment', payload);
        if (payload.recommentOffset <= payload.recommentCnt) {
          this.selectRecomments({ second: this.time, postIdx: this.idx, commentIdx: payload.commentIdx, offset: payload.recommentOffset });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    border-bottom: 2px solid #f4f4f4;
    /*box-shadow: 0 4px 36px rgba(234, 234, 234, 50);*/
  }

  .custom-chip {
    &-small {
      height: 24px;
      border: 1px solid #eaeaea;
      font-size: 10px;
      line-height: 10px;
      letter-spacing: -0.36px;
      color: #4a4a4a !important;
      background-color: white !important;
      margin: 0;
    }
    &-background {
      background-color: #f4f4f4 !important;
    }
  }
  .custom-chip-small + .custom-chip-small {
    margin-left: 8px;
  }
  /deep/.custom-chip-small .v-chip__content {
    padding-left: 8px;
    padding-right: 8px;
  }

  .post-title {
    padding: 0 16px;
    margin-bottom: 24px;
    background-color: white;

    text-align: left;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.34px;
    font-weight: 700;
    color: #4a4a4a;

    word-break: keep-all;
    word-wrap: break-word;
  }

  .feed-swiper-container {
    width: 100vw;
    height: calc(100vw * 9 / 16 + 21px);
  }

  /deep/.feed-swiper-pagination {
    position: absolute;
    bottom: 0;

    .swiper-pagination-bullet {
      display: inline-block;
      width: 6px;
      height: 6px;
      opacity: 1;
      background: map_get($colors, background-shadow);;
      border-radius: 50%;
    }
    .swiper-pagination-bullet-active {
      background: #ec2f54;
    }
  }

  /deep/.menu-icon .v-btn__content {
    flex-direction: column;
    & > span {
      font-size: 10px;
      line-height: 14px;
      font-weight: 700;
      letter-spacing: -0.2px;
      color: map_get($colors, charcoal);
    }
  }
  .body-2 {
    line-height: 20px;
    word-break: keep-all;
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  .user-name {
    color: map_get($colors, brownish-grey);
    font-size: 10px;
  }

  .caption {
    color: map_get($colors, brownish-grey);
    font-size: 10px !important;
  }

  .counter {
    color: map_get($colors, brownish-grey);
    font-size: 10px;
    /*font-weight: 700;*/
    line-height: 14px;
    margin-top: -5px;
    //letter-spacing: -0.2px;
  }

  /deep/.border-radius-custom {
    overflow: hidden;
    border-radius: 21px !important;
    .v-input__slot {
      cursor: pointer !important;
      padding: 0 5px 0 18px !important;
    }
    textarea {
      margin-top: 0 !important;
      cursor: pointer !important;
    }
    .v-input__append-inner {
      margin-top: 0 !important;
      align-self: center !important;
      font-size: 10px;
      line-height: 14px;
      letter-spacing: -0.2px;
      .submit-comment {
        font-size: 10px;
        line-height: 14px;
        letter-spacing: -0.2px;
      }
    }
  }

  .counter {
    margin-top: 5px;
    color: map_get($colors, charcoal);
    font-size: 10px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: -0.2px;
  }
</style>
